<template>
  <div class="login text-white w-100 px-md-5">
    <h1 class="mb-5">
      Login
    </h1>

    <form action="login" class="d-flex flex-column">
      <input
        type="text"
        v-model="email"
        class="mb-4"
        placeholder="Email address"
        name="email"
      />
      <input
        type="password"
        v-model="password"
        placeholder="Password"
        name="password"
      />
      <a
        href="#"
        @click="$router.push({ name: 'Forgot Password' })"
        class="mb-4 mt-2 small"
      >
        forgot your password?
      </a>

      <button
        type="submit"
        class="btn btn-light-blue mb-4"
        @click.prevent="login"
      >
        Login
      </button>

      <div>
        Don't have an account?
        <a @click.prevent="$router.push({ name: 'Signup' })" href="#"
          ><u>Signup <i class="fa fa-chevron-right"></i></u
        ></a>
      </div>
    </form>

    <p class="text-center my-4">or</p>
    <button @click="login('google')" class="w-100">
      <i class="fab fa-google"></i> <span class="ml-2">Login with Google</span>
    </button>
  </div>
</template>

<script>
// @ is an alias to /src
import useLogin from "@/composables/useLogin";

export default {
  name: "home",
  data() {
    return {
      email: "",
      password: ""
    };
  },
  computed: {
    displayPassword() {
      let pass = "";
      this.password.forEach(() => {
        pass.push("*");
      });
      return pass;
    }
  },
  methods: {
    async login(method) {
      const { login, loginWithGoogle } = useLogin();
      let user;
      try {
        if (method === "google") {
          user = await loginWithGoogle().user;
        } else {
          user = await login(this.email, this.password);
        }
        if (user) {
          this.$toasted.show("You are logged in", {
            theme: "bubble",
            position: "top-right",
            duration: 5000
          });
          this.$router.push("/dashboard");
        } else {
          this.$toasted.show("Username or password wrong", {
            theme: "bubble",
            position: "top-right",
            duration: 5000
          });
        }
      } catch (e) {
        console.error(e);
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
a {
  color: #fff;
}
</style>
